<template>
    <div class="visualization">
        <div class="panel">
            <el-input v-model="contractNO" placeholder="请输入合同编号" size="mini" class="panel-input"></el-input>
            <el-button type="primary" size="mini" @click="search" :loading="searchLoading" class="bigData-btn-search">搜索</el-button>
            <el-button type="primary" size="mini" @click="showInfo">车辆与合同信息</el-button>
        </div>
        <div class="Bmap" id="Bmap"></div>
        <el-dialog
            title="车辆与合同信息"
            :visible.sync="dialogVisible"
            width="40%"
            :before="hideInfo">
            <div>
                <el-form label-width="100px">
                    <el-form-item label="车牌号：">
                        <span>{{this.info.ettaEtveCard || ''}}</span>
                    </el-form-item>
                    <el-form-item label="主驾姓名：">
                        <span>{{this.info.ettaMainEttpName || ''}}</span>
                    </el-form-item>
                    <el-form-item label="联系电话：">
                        <span>{{this.info.ettaEttpTel || ''}}</span>
                    </el-form-item>
                    <el-form-item label="发货单位：">
                        <span>{{this.info.ettaShipperEbspNameCn || ''}}</span>
                    </el-form-item>
                    <el-form-item label="收货单位：">
                        <span>{{this.info.ettaConsigneeEbspNameCn || ''}}</span>
                    </el-form-item>
                    <el-form-item label="承运商：">
                        <span>{{this.info.ettaCarrierEbcuNameCn || ''}}</span>
                    </el-form-item>
                    <el-form-item label="线路：">
                        <span>{{this.info.ettaEblnLineName || ''}}</span>
                    </el-form-item>
                    <el-form-item label="发货时间：">
                        <span>{{this.info.ettaLoadingDate || ''}}</span>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="hideInfo">取 消</el-button>
                <el-button type="primary" @click="hideInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import loadBMap from './loadBMap';
import { getCoordinates } from '../../../api/passage';
const startPg = require('@/assets/map_start.png');
const endPg = require('@/assets/map_end.png');
export default {
    mounted() {
        this.$nextTick(res => {
            this.initMap();
        });
    },
    data() {
        return {
            contractNO: '',
            searchLoading: false,
            list: [], // 地图标点集合
            startStation: '',
            endStation: '',
            dialogVisible: false,
            BMap: null,
            driving: null,
            info: {}
        };
    },
    methods: {
        _getCoordinates() {
            if (!this.contractNO) {
                this.$message.error('请输入合同编号');
                return false;
            }
            this.searchLoading = true;
            getCoordinates({
                contractNo: this.contractNO
            }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.startStation = res.data.data.startStation;
                        this.endStation = res.data.data.endStation;
                        this.list = res.data.data.actualTrackings;
                        this.info = res.data.data.etTask;
                        if (this.startStation && this.endStation) {
                            this.initMapPoint();
                        } else {
                            this.info = {};
                            this.$message.error('起点或终点不存在');
                        }
                    } else {
                        this.info = {};
                        this.$message.error(res.data.messagesAsString);
                    }
                } else {
                    this.$message.error(res.msg);
                }
                this.searchLoading = false;
            });
        },
        initMapPoint() {
            const BMap = this.BMap;
            // 地图坐标
            const p1 = new BMap.Point(this.startStation.eblcLongitude, this.startStation.eblcLatitude);
            const p2 = new BMap.Point(this.endStation.eblcLongitude, this.endStation.eblcLatitude);
            const arrPoint = this.list.map(item => {
                return new BMap.Point(item.etisLongitude, item.etisLatitude);
            });
            // 清除覆盖物
            this.map.clearOverlays();
            // 瞄点
            const startIcon = new BMap.Icon(startPg, new BMap.Size(30, 50), { anchor: new BMap.Size(15, 50) }); // eslint-disable-line
            const endIcon = new BMap.Icon(endPg, new BMap.Size(30, 50), { anchor: new BMap.Size(15, 50) }); // eslint-disable-line
            this.map.addOverlay(new BMap.Marker(p1, { icon: startIcon }));
            this.map.addOverlay(new BMap.Marker(p2, { icon: endIcon }));
            this.list.forEach(item => {
                const marker = new BMap.Marker(new BMap.Point(item.etisLongitude, item.etisLatitude));
                this.map.addOverlay(marker);
                // 添加红点点击事件
                marker.addEventListener('click', (e) => {
                    this.openInfo(item.etisLocation, item.etisDate, e);
                });
            });
            // 绘制路线
            const polyline = new BMap.Polyline([p1, ...arrPoint, p2]);
            this.map.addOverlay(polyline);
            // 定位到点上
            this.map.setViewport([p1, ...arrPoint, p2]);
        },
        openInfo(adder, date, e) {
            const p = e.target;
            const BMap = this.BMap;
            // 定义窗口信息
            const opts = {
                width: 300, // 信息窗口宽度
                height: 100, // 信息窗口高度
                title: '定位信息',
                enableMessage: true // 设置允许信息窗发送短息
            };
            const point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
            const node = `<div><span>定位地点: </span>${adder}</div><div><span>定位时间: </span>${date}</div>`;
            const infoWindow = new BMap.InfoWindow(node, opts); // 创建信息窗口对象
            this.map.openInfoWindow(infoWindow, point); // 开启信息窗口
        },
        search() {
            this._getCoordinates();
        },
        initMap() {
            loadBMap('6N54N3ujNCfK9bKovNfqRcOnCHuoBoX7').then(BMap => {
                this.BMap = BMap;
                this.map = new BMap.Map('Bmap');
                const map = this.map;
                map.centerAndZoom(new BMap.Point(116.404, 39.915), 13); // eslint-disable-line
                map.setCurrentCity('北京');
                map.enableScrollWheelZoom(true); // 是否可缩放
            });
        },
        showInfo() {
            if (Object.keys(this.info).length) { // Object.keys取对象的属性值组成数组
                this.dialogVisible = true;
            } else {
                this.$message.error('未查询到车辆与合同信息!');
            }
        },
        hideInfo() {
            this.dialogVisible = false;
        }
    }
};
</script>
<style lang="less">
.visualization{
    min-height: calc(~ '100vh - 146px') !important;
    max-height: calc(~ '100vh - 146px') !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .panel{
        flex: 0 0 38px;
        &-input{
            width: 150px;
            margin-right: 10px;
        }
    }
    .Bmap{
        flex: 1;
    }
}
</style>